import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CharacteristicConsultService } from 'src/app/pages/register/characteristic-consult/services/characteristic-consult.service';
import { Beneficiaries } from 'src/app/shared/interfaces/beneficiaries';
import { CarbonOperation } from 'src/app/shared/interfaces/carbon-operation';

import { WithdrawalBeneficiaryRow } from '../modal-beneficiaries-table/modal-beneficiaries-table.component';

import {
  isAcxRetirementOperation,
  mapRetirementBeneficiariesToViews,
  RetirementEntityView,
} from '../shared/operation-retirement-details.utils';
import {
  OperationTypeBadge,
  resolveOperationTypeBadge,
} from '../shared/operation-type-badge.utils';

@Component({
  standalone: false,
  selector: 'app-operation-retirement-details-drawer',
  templateUrl: './operation-retirement-details-drawer.component.html',
  styleUrls: ['./operation-retirement-details-drawer.component.scss'],
})
export class OperationRetirementDetailsDrawerComponent implements OnChanges {
  @Input() open = false;
  @Input() operation: CarbonOperation | null = null;
  @Output() openChange = new EventEmitter<boolean>();

  entities: RetirementEntityView[] = [];
  isLoading = false;

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['open'] || changes['operation']) && this.open && this.operation) {
      this.loadDetails(this.operation);
    }

    if (changes['open'] && !this.open) {
      this.entities = [];
    }
  }

  get operationTypeBadge(): OperationTypeBadge {
    return this.operation ? resolveOperationTypeBadge(this.operation) : {
      label: 'Retirada',
      icon: 'logout',
      tone: 'warning',
    };
  }

  get isAcxMode(): boolean {
    return this.operation ? isAcxRetirementOperation(this.operation) : false;
  }

  get entitiesCountLabel(): string {
    return `${this.entities.length}`;
  }

  close(): void {
    this.open = false;
    this.openChange.emit(false);
  }

  constructor(
    private readonly characteristicConsultService: CharacteristicConsultService,
  ) {}

  private loadDetails(operation: CarbonOperation): void {
    if (this.isAcxMode) {
      this.entities = [];
      this.isLoading = false;
      return;
    }

    if (!operation.operationId) {
      this.entities = [];
      this.isLoading = false;
      return;
    }

    this.isLoading = true;

    this.characteristicConsultService.getBeneficiaries(operation.operationId).subscribe({
      next: (response) => {
        const beneficiaries = (response.data ?? []) as Array<WithdrawalBeneficiaryRow | Beneficiaries>;
        this.entities = mapRetirementBeneficiariesToViews(beneficiaries);
        this.isLoading = false;
      },
      error: () => {
        this.entities = [];
        this.isLoading = false;
      },
    });
  }
}
